<template>
  <div class="dast-promo-feature">
    <div v-if="icon" class="dast-promo-feature-icon">
      <component :is="icon" :fill="'white'" />
    </div>
    <div class="dast-promo-feature-text">{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: 'DastPromoFeature',
  props: {
    icon: {
      type: [Object, Function],
    },
    text: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.dast-promo-feature {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-direction: row;
  background-color: white;
  padding: 0.75rem;
  border-radius: 8px;
  width: fit-content;
}

$icon-size: 28px;
.dast-promo-feature-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: $icon-size;
  height: $icon-size;
  background: #1a59f6;
  border-radius: 8px;
}

.dast-promo-feature-text {
  font-family: 'Aspekta', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.4;
  color: #242424;
}
</style>
